import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from '../components/Header';
import Footer from '../components/Footer';
import usePageTitle from '../hooks/usePageTitle';
import useCanonicalTag from '../hooks/useCanonicalTag';
import useMetaTags from '../hooks/useMetaTags';
import '../styles/fonts.css';

const TOOLS = [
  {
    to: '/tools/fuel',
    icon: 'fas fa-gas-pump',
    color: '#e3b341',
    titleKey: 'tools.fuel.title',
    descKey: 'tools.fuel.desc',
  },
  {
    to: '/tools/endurance',
    icon: 'fas fa-stopwatch',
    color: '#58a6ff',
    titleKey: 'tools.endurance.title',
    descKey: 'tools.endurance.desc',
  },
  {
    to: '/tools/fov',
    icon: 'fas fa-desktop',
    color: '#3fb950',
    titleKey: 'tools.fov.title',
    descKey: 'tools.fov.desc',
  },
];

function Tools() {
  const { t } = useTranslation();
  usePageTitle(t('tools.pageTitle'));
  useCanonicalTag();
  useMetaTags({
    title: 'Tools | Celeritas',
    description: 'Free sim racing tools: fuel calculator, FOV calculator, endurance planner and more.',
    url: 'https://celeritas.live/tools',
  });

  return (
    <div style={{ minHeight: '100vh', background: '#1b1f23', display: 'flex', flexDirection: 'column' }}>
      <Header />
      <main style={{ flex: 1, maxWidth: '860px', margin: '0 auto', padding: '48px 24px', color: '#c9d1d9' }}>

        <h1 style={{ fontSize: '28px', fontWeight: 700, color: '#fff', marginBottom: '8px' }}>
          {t('tools.pageTitle')}
        </h1>
        <p style={{ fontSize: '13px', color: '#8b949e', marginBottom: '40px' }}>
          {t('tools.pageSubtitle')}
        </p>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px' }}>
          {TOOLS.map(tool => (
            <ToolCard key={tool.to} tool={tool} label={t(tool.titleKey)} desc={t(tool.descKey)} openLabel={t('tools.open')} />
          ))}
        </div>

      </main>
      <Footer />
    </div>
  );
}

function ToolCard({ tool, label, desc, openLabel }) {
  return (
    <Link to={tool.to} style={{ textDecoration: 'none' }}>
      <div
        style={{
          background: '#21262d',
          border: '1px solid #30363d',
          borderRadius: '10px',
          padding: '28px 24px',
          display: 'flex',
          flexDirection: 'column',
          gap: '12px',
          transition: 'border-color 0.2s, transform 0.15s',
          cursor: 'pointer',
          height: '100%',
          boxSizing: 'border-box',
        }}
        onMouseEnter={e => { e.currentTarget.style.borderColor = tool.color; e.currentTarget.style.transform = 'translateY(-2px)'; }}
        onMouseLeave={e => { e.currentTarget.style.borderColor = '#30363d'; e.currentTarget.style.transform = 'translateY(0)'; }}
      >
        <i className={tool.icon} style={{ fontSize: '26px', color: tool.color }} />
        <div>
          <div style={{ fontSize: '16px', fontWeight: 700, color: '#e6edf3', marginBottom: '6px' }}>
            {label}
          </div>
          <div style={{ fontSize: '13px', color: '#8b949e', lineHeight: '1.6' }}>
            {desc}
          </div>
        </div>
        <div style={{ marginTop: 'auto', paddingTop: '8px', fontSize: '12px', color: tool.color, fontWeight: 600 }}>
          {openLabel} →
        </div>
      </div>
    </Link>
  );
}

export default Tools;
